import React, { useEffect, useRef, useState } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import defaultCompanyLogo from "@/assets/images/svg/Company-logo.svg";
import defaultUser from "@/assets/images/svg/viewProfileContact_img.svg";

import fb from "@/assets/images/webp/fb-1.webp";
import linkedIn from "@/assets/images/webp/linked.webp";
import insta from "@/assets/images/webp/instaicon.webp";
import youtube from "@/assets/images/webp/youtube.webp";
import twitter from "@/assets/images/svg/twitter.svg";
import other from "@/assets/images/webp/Other1.webp";

import { Link, useLocation, useMatch, useNavigate, useParams } from "react-router-dom";
import { getLandingProfile } from "@/actions/memberAction";
import { connect } from "react-redux";
import _, { capitalize, isEmpty, size, toLower, truncate, slice, map, lowerCase, parseInt, find, findIndex, isEqual } from "lodash";
import { setAuthHeaders, showSuccessMessage, webSiteURL, getPrefix, buildPath } from "@/utils/common";
import defaultValues from "@/constant/defaultValues";
import ROUTES from "@/config/routePath";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";

import LargePopupCertificate from "@/components/LargePopupCertificate";
import { hideLoading, showLoading } from "@/actions/loaderAction";
import BasicPartner from "@/assets/images/png/Basic-Partner.png";
import ProPartner from "@/assets/images/png/Pro-Partner.png";
import PlusPartner from "@/assets/images/png/Plus-Partner.png";
import ElitePartner from "@/assets/images/png/Elite-Partner.png";

import { publicRoutePaths } from "@/routes/public.routes.config";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import ImageVideo from "@/modules/frontend/components/Landing_Page/ImageVideo";
import PopUp from "@/modules/frontend/components/PopUp";

import MobBanner from "@/assets/images/webp/landing-mobile-banner.webp";
import ProductCarousel from "@/modules/frontend/components/Market_Place/Product/ProductCarousel";
import { useAuth } from "@/AuthProvider";
import RegistrationPopup from "@/components/RegistrationPopup";
import API_URL from "@/constant/api.config";
import axiosInstance from '@/axiosHttp';
import SupplierInqPopup from "../../components/Inquiry/SupplierInqPopup";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { updateMemberCredit } from "@/actions/viewProfileAction";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";


const Index = (props) => {

  const { id } = useParams();
  const { IMAGE_PATH } = defaultValues;


  const nav = useNavigate();
  const location = useLocation();

  const { user, isPreKYCUser, isEndUser, isSuperAdmin, isViewer, isOpUser, isInqUser } = useAuth();
  
  const creditUpdatedRef = useRef(null);

  const [profileDetail, setProfileDetail] = useState(null);
  const [cImages, setCImages] = useState([]);
  const [memberHeadAddress, setMemberHeadAddress] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCertiExpanded, setIsCertiExpanded] = useState(false);
  const [isCompanyInfoExpanded, setIsCompanyInfoExpanded] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [registermodalShow, setRegisterModalShow] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [maskedData, setMaskedData] = useState(true);
  const [badgeSrc, setBadgeSrc] = useState('');
  const [largemodalShow, setLargeModalShow] = useState(false);
  const [companyStatus, setCompanyStatus] = useState(null);
  // const landingCarouselRef = useRef("landing");
  const [isHsnCodeExpanded, setIsHsnCodeExpanded] = useState(false);
  const [isTradingCountryExpanded, setIsTradingCountryExpanded] = useState(false);
  const [isPortExpanded, setIsPortExpanded] = useState(false);
  const [isContactsExpanded, setIsContactsExpanded] = useState(false);
  const [mediaType, setMediaType] = useState("ALL");
  const [cVideos, setCVideos] = useState([]);
  const [mediumModalShow, setMediumModalShow] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");

  const [landing_products, setLandingProducts] = useState([]);

  const [visitor_type, setVisitorType] = useState("supplier");
  const [email, setEmail] = useState(null);
  const [inqmodalshow, setInqModalShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [regModal, setRegModalShow] = useState(false);

  const [creditModal, setCreditModalShow] = useState(false);

  const match = useMatch(publicRoutePaths.COMPANY_CATALOGUE.path);
  //console.log("Match ========================= ", match);

   const isPaidSupplier =
    !!user &&
    user.trade_mode_type === "SUPPLIER" &&
    !!user.company_plan_name &&
    user.company_plan_name !== "Trial";


  const canSendInquiry =
    !!user && (isEndUser || user.trade_mode_type === "BUYER" || isPaidSupplier);


  const toggleReadMore = () => {
    // setIsExpanded(!isExpanded);
    setPopupTitle('Services');
    setMediumModalShow(true);

  };

  const toggleCertiReadMore = () => {
    setIsCertiExpanded(!isCertiExpanded);
  };

  const toggleCompanyInfoReadMore = () => {
    setIsCompanyInfoExpanded(!isCompanyInfoExpanded);
  };

  const toggleHSNReadMore = () => {
    // setIsHsnCodeExpanded(!isHsnCodeExpanded);
    setPopupTitle('HSN Code');
    setMediumModalShow(true);
  };

  const toggleTradingCountryReadMore = () => {
    // setIsTradingCountryExpanded(!isTradingCountryExpanded);
    setPopupTitle('Trading Countries');
    setMediumModalShow(true);
  };
  const togglePortReadMore = () => {
    // setIsPortExpanded(!isPortExpanded);
    setPopupTitle('Ports');
    setMediumModalShow(true);
  };

  const toggleContactsReadMore = () => {
    setIsContactsExpanded(!isContactsExpanded);
  };

  const handleRegistrationPopup = () => {
    nav(ROUTES.REGISTRATION);
  };

  const handlefavoriteClick = async (pdata) => {
    if(user) {
      let reqObj = {
        product_id : pdata.id
      }

      const response = await axiosInstance.post(API_URL + "/favorite-product", reqObj);
      let res = response.data ? response.data : null;
      if(res.status) {
        showSuccessMessage(res.message);
       /* const pdetail = {...profileDetail};
        if(pdetail && !isEmpty(pdetail.landing_products)) {
          let p = find(pdetail.landing_products, (val) => val.id === pdata.id);
          let pIndex = findIndex(pdetail.landing_products, (val) => val.id === pdata.id);
          
          if(res.message == "Product removed from favorite") {
            p.isFavorite = false;
          } else {
            p.isFavorite = true;
          }

          pdetail.landing_products[pIndex] = p;

          setProfileDetail(pdetail);

        } */
      }
    } else {
      setRegModalShow(true);
    }
  }

  const handleUpgradePlanClick = async () => {
    if (user) {
      let data = {
        member_id: user.member_id
      }

      const headers = setAuthHeaders();
      const response = await axiosInstance.post(API_URL + "/member/upgrade-plan-request", data, {
        headers
      });

      if (response) {
        if (response.data) {
          setRegisterModalShow(false);
           if (user.trade_mode_type !== 'SUPPLIER') {
             showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
           } else {
             setTimeout(() => {
                nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`)
            }, 500);
           }
         
        }
      }
    }
  }

  const handleInqQuoteClick = () => {
    let products = map(landing_products, (val, k) => {
      return {
        product_name: val.product_name,
        id: val.id,
        minimum_order: val.minimum_order
      }
    })

    let data = {
      id: id,
      selected_product_id: "",
      products: products,
      company_logo: profileDetail && profileDetail.company_logo,
      company_name: profileDetail.company_name,
      country: profileDetail && profileDetail.country,
      industy_name: profileDetail && profileDetail.member_industry && profileDetail.member_industry.industy_name
    }
    setSelectedSupplier(data);

    // if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
    //   setInqModalShow(true);
    // } else {
    //   setRegisterModalShow(true);
    // }
     if (canSendInquiry) {
      setRegisterModalShow(false);
      setInqModalShow(true);
    } else {
      setInqModalShow(false);
      setRegisterModalShow(true);
      
    }
  }

  const handleInqModal = () => {

    let products = map(landing_products, (val, k) => {
      return {
        product_name: val.product_name,
        id: val.id,
        minimum_order: val.minimum_order
      }
    })

    let data = {
      id: id,
      selected_product_id: "",
      products: products,
      company_logo: profileDetail && profileDetail.company_logo,
      company_name: profileDetail.company_name,
      country: profileDetail && profileDetail.country,
      industy_name: profileDetail && profileDetail.member_industry && profileDetail.member_industry.industy_name
    }
    setSelectedSupplier(data);
    setInqModalShow(true)
    setRegisterModalShow(false);
  }

  const redirectFun = (e, id) => {
    e.preventDefault();
    setRegisterModalShow(false);

    setTimeout(() => {
      // navigate(publicRoutePaths.REGISTRATION.path);
      window.open(publicRoutePaths.REGISTRATION.path);
    }, 100);

  };

  const handleRegisterBtnClick = () => {
    nav(publicRoutePaths.REGISTRATION.path);
  }

  useEffect(() => {
    if (isCompanyInfoExpanded) {
      if (profileDetail && !isEmpty(profileDetail.memberdetail)) {
        setCompanyInfo(profileDetail.memberdetail.about_company);
      } else {
        let truncatedInfo = truncate(profileDetail.memberdetail.about_company, {
          'length': 1000,
          'omission': ""
        });
        setCompanyInfo(truncatedInfo);
      }
    } else {
      if (profileDetail && !isEmpty(profileDetail.memberdetail)) {
        if (size(profileDetail.memberdetail.about_company) > 1000) {
          let truncatedInfo = truncate(profileDetail.memberdetail.about_company, {
            'length': 1000,
            'omission': ""
          });
          setCompanyInfo(truncatedInfo);
        } else {
          setCompanyInfo(profileDetail.memberdetail.about_company);
        }
      }
    }
  }, [isCompanyInfoExpanded])

  useEffect(() => {

    const fetchData = async (basAPIName) => {
      setShowLoader(true);
      await props.getLandingProfileData(basAPIName, id).then(async (data) => {

        if (!isEmpty(data)) {
          setCompanyStatus(data[0].status);
          if (basAPIName === 'landing-profiles') {
            console.log('Landing Page Not allowed', data);
            setMaskedData(false);

            if (data[0].status == 1) {


              if (data[0].badge == "Elite") {
                setBadgeSrc(ElitePartner);
              } else if (data[0].badge == "Basic") {
                setBadgeSrc(BasicPartner);
              } else if (data[0].badge == "Pro") {
                setBadgeSrc(ProPartner);
              } else if (data[0].badge == "Plus") {
                setBadgeSrc(PlusPartner);
              }

            }
          } else {
            setMaskedData(true);

            if (data[0].plan_name != "Trial") {
              if (data[0].badge == "Elite") {
                setBadgeSrc(ElitePartner);
              } else if (data[0].badge == "Basic") {
                setBadgeSrc(BasicPartner);
              } else if (data[0].badge == "Pro") {
                setBadgeSrc(ProPartner);
              } else if (data[0].badge == "Plus") {
                setBadgeSrc(PlusPartner);
              }
            }



          }

          if (match && match?.pattern?.path == publicRoutePaths.COMPANY_CATALOGUE.path) {
              console.log("location =============== ", location, " >>>>> user <<<<<< ", user)
              if (user && user.role_slug && (user.role_slug.slug !== roles.VIEWER.slug_name && user.role_slug.slug !== roles.SUPER_ADMIN.slug_name && user.role_slug.slug !== roles.DEMO.slug_name && user.role_slug.slug !== roles.OPERATION_USER.slug_name && user.role_slug.slug !== roles.PRE_KYC.slug_name && user.role_slug.slug !== roles.INQ_MANAGER.slug_name)) {
                const creditKey = `${user.member_id}-${id}`;
                if (creditUpdatedRef.current !== creditKey) {
                  creditUpdatedRef.current = creditKey;
                  await props.updateMemberCredit(user.member_id, id);
                }
              }   
          }

          setProfileDetail(data[0]);

          if (!isEmpty(data[0].head_office_address)) {
            setMemberHeadAddress(data[0].head_office_address[0]);
          } else {
            let tmpHeadOffice = {
              address1: null,
              address2: null,
              city: null,
              country: (!isEmpty(data[0].head_office_country)) ? data[0].head_office_country : '',
              country_id: (!isEmpty(data[0].head_office_country)) ? data[0].head_office_country.id : '',
              office_type: 'Head',
              pincode: null,
              member_id: id
            };
            setMemberHeadAddress(tmpHeadOffice);
          }

          if (!isEmpty(data[0].images)) {
            let r = data[0].images.map((val) => {
              let x1 = val;
              x1.src = IMAGE_PATH.BASE_URL + '/company_images/' + val.detail;
              return x1;
            });
            setCImages(r);
          }

          if (!isEmpty(data[0].videos)) {
            let r = data[0].videos.map((val) => {
              let x1 = val;
              x1.src = val.detail;
              return x1;
            });
            setCVideos(r);
          }


          if (!isEmpty(data[0].memberdetail) && !isEmpty(data[0].memberdetail.about_company)) {

            let truncatedCompanyInfo = data[0].memberdetail.about_company;
            if (size(data[0].memberdetail.about_company) > 1000) {
              truncatedCompanyInfo = truncate(data[0].memberdetail.about_company, {
                'length': 1000,
                'omission': ""
              });

              setCompanyInfo(truncatedCompanyInfo);
            } else {
              setCompanyInfo(truncatedCompanyInfo);
            }

          }

          if (!isEmpty(data[0].landing_products)) {
            setLandingProducts(data[0].landing_products);
          }

        } else {

          if (match) {
            nav(publicRoutePaths.COMPANY_PAGE_NOT_FOUND.path);
          } else {
            nav(publicRoutePaths.LANDING_PAGE_NOT_FOUND.path);
          }

        }

        setTimeout(() => {
          setShowLoader(false);
        }, 2000);
      }).catch((err) => {
        console.log("Error >>>>>>> ", err);
        setShowLoader(false);
      });
    }

    /* if (!props.masking) {
      /*if (includes(id, [LANDING_PAGE_IDS])) {
        fetchData('landing-profiles');
        setMaskedData(false);
      } else {
        setMaskedData(true);
        nav(ROUTES.REGISTRATION);
      }*/
    /*fetchData('landing-profiles');
  } else {
    fetchData('profiles');
    setMaskedData(true);
  } */

    if (match) {
      if (!user) {
        fetchData('profiles');
      } else {
        fetchData('company-profiles');
      }

    } else {
      fetchData('landing-profiles');
    }



  }, [id, match, user]);

   

    useEffect(() => {
        console.log("regmodalShow:", regModal);
        console.log("user:", user);
    
        if (
            regModal &&
            user?.trade_mode_type === "SUPPLIER" &&
            (user?.company_plan_name !== "Trial")
        ) {
            console.log("Supplier paid user - switching modal");
            if(isPreKYCUser) {
              setInqModalShow(false);
              setRegisterModalShow(true);
              
            } else {
              setRegisterModalShow(false);
              setInqModalShow(true);
            }
             
        }
  
        
    }, [regModal, user,isPreKYCUser]);

    // useEffect(() => {
    
    //       setInterval(() => {
    //         let u = localStorage.getItem("user");
    //         u = JSON.parse(u);
    //         if(!isEqual(u, user) && user?.company_plan_name !== "Trial" && parseInt(user?.current_step) === 4) {
    //           window.location.reload();
    //         }
    //       },1500);
    //    },[user]);


  //console.log(" >>>>>>>>>>>>>> ", profileDetail);

  return (<>
    <section className="inner-pad page contact-us-wrape landing-page">
      <SeoHelmet
        title={seoConfig.landingPage.title}
        description={seoConfig.landingPage.description}
        keywords={seoConfig.landingPage.keywords}
        author={seoConfig.landingPage.author}
      />
      {/* inner banner wrape START  */}
      <div className="inner-banner">
        {/* <div className="container">
          <div className="content-wrape">

          </div>
        </div> */}

        <img src={MobBanner} alt="" className="mob-banner" />
      </div>
      {/* inner banner wrape END  */}

      <LargePopupCertificate
        // title="Certificate"
        LargeModalShow={largemodalShow}
        setLargeModalShow={setLargeModalShow}
        pdfUrl={profileDetail && IMAGE_PATH.BASE_URL + profileDetail.orex_certificate}
        pageSource="landingPage"
      >
      </LargePopupCertificate>

      {showLoader && <ScreenLoaderHome />}

      <section className={`inner-banner-wrape ${profileDetail && profileDetail.trade_mode_type === "LOG_PTR" ? "logistics" : (profileDetail && profileDetail.trade_mode_type !== "LOG_PTR") ? "buyer-supplier" : ""} banner-wrape`}>
      </section>

      {/* <div className="landing container-fluid">
        <div className="container">
          <div className="landing-banner-title">
            {profileDetail && profileDetail.company_name}
          </div>
          <div className="landing-banner-breadcrumbs">
            <span onClick={() => nav(ROUTES.HOME)}> <b>Home <i className="fa-solid fa-angle-right"></i> </b></span>
            {maskedData && <span onClick={() => nav(ROUTES.LOGISTIC_PARTNER)}> <b> Find partner <i className="fa-solid fa-angle-right"></i> </b> </span>}
            <b>Business Detail</b>
          </div>
        </div>
      </div> */}

      <div className="agro-content-wraper">
        <div className="container">
          <div className="inner-wrape">
            {/* left-wrape START */}
            <div className="left-wrape">
              {/* company_logo-details */}
              <div className="company-card company-card-info">
                <div className="company-info-logo">
                  <div className=" company-prifile-logo">
                    <div className="logo-img ">
                      <img
                        src={profileDetail && !isEmpty(profileDetail.company_logo) ? IMAGE_PATH.BASE_URL + profileDetail.company_logo : defaultCompanyLogo}
                        alt=""
                        className="profile-imges w-100"
                      />
                    </div>
                    {
                      profileDetail && !isEmpty(profileDetail.social_medias) && <div className="company-socialmedia-main">
                        <div className="company-socialmedia">
                          {
                            profileDetail.social_medias.map((val) => {
                              let imgSrc = other;
                              if (!isEmpty(val.detail)) {
                                let detail = JSON.parse(val.detail);
                                let l = detail.label;
                                let lbl = l;
                                if (!isEmpty(l)) {
                                  lbl = toLower(l);
                                }

                                if (!isEmpty(lbl)) {
                                  switch (lbl) {
                                    case "facebook":
                                      imgSrc = fb;
                                      break;
                                    case "twitter":
                                      imgSrc = twitter;
                                      break;
                                    case "instagram":
                                      imgSrc = insta;
                                      break;
                                    case "youtube":
                                      imgSrc = youtube;
                                      break;
                                    case "linkedin":
                                      imgSrc = linkedIn;
                                      break;
                                    default:
                                      imgSrc = other;
                                      break;
                                  }

                                  let link = detail.Link;

                                  if (link.indexOf("http://") === 0 || link.indexOf("https://") === 0) {
                                    return (<a href={`${link}`} target='_blank' rel="noreferrer" title="Social Media"><img src={imgSrc} alt="" /></a>)
                                  } else {
                                    return (<a href={`http://${detail.Link}`} target='_blank' rel="noreferrer" title="Social Media"><img src={imgSrc} alt="" /></a>)
                                  }
                                }
                              }
                            })
                          }
                        </div>
                      </div>
                    }


                  </div>

                  <div className="NFT_Roadway">
                    <div className="NFT-company-name">
                      {/* <h3>{profileDetail && profileDetail.company_name}</h3> */}
                      <div className="title-detail-wrape d-flex gap-3 justify-space-between align-items-start">
                        <div>
                          <h1>{profileDetail && profileDetail.company_name}</h1>
                          <span>
                            <i className="sprite location"></i>
                            {profileDetail && profileDetail.member_city && profileDetail.member_city.name + ","} {profileDetail && profileDetail.country && profileDetail.country.name}
                          </span>
                        </div>
                        <div className="button-wrapes">
                          {
                            match && user && user.trade_mode_type !== "LOG_PTR" && !isSuperAdmin && !isViewer && !isOpUser && !isInqUser && (parseInt(user.member_id) !== parseInt(id)) && <button type="button" className="btn outline medium" onClick={handleInqQuoteClick}>Contact Supplier
                              <span class="round"><i class="sprite"></i></span>
                            </button>
                          }

                          {
                            match && !user && <button type="button" className="btn outline medium" onClick={handleInqQuoteClick}>Contact Supplier
                              <span class="round"><i class="sprite"></i></span>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="compny-detail">
                      <div className="row">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12">
                          Orex ID
                        </p>
                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && profileDetail.member_unique_number}
                        </p>
                      </div>

                      <div className="row ">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12">
                          Established Year
                        </p>
                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && !isEmpty(profileDetail.establish_date) ? profileDetail.establish_date : "-"}
                        </p>
                      </div>

                      <div className="row">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12">
                          Industry of Work
                        </p>
                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && profileDetail.member_industry.industy_name}
                        </p>
                      </div>

                      <div className="row">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12 ">
                          Company Size
                        </p>
                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && !isEmpty(profileDetail.company_size) ? profileDetail.company_size : '-'}
                        </p>
                      </div>

                      <div className="row">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12 ">
                          Trade Mode
                        </p>
                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && profileDetail.shipment_mode}
                        </p>
                      </div>

                      <div className="row">
                        <p className="col-xxl-3 col-xl-4 col-md-4 col-sm-5 col-12">
                          Website
                        </p>
                        {/* <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && !isEmpty(profileDetail.website) ? (profileDetail.website != "#lock#") ? webSiteURL(profileDetail.website) : <button type="button" className="lock-button" onClick={() => setRegisterModalShow(true)}>View <i className="fa-solid fa-lock"></i></button> : "-"}
                        </p> */}

                        <p className="col-xxl-9 col-xl-8 col-md-7 col-sm-7 col-12 company-detials-info">
                          {profileDetail && !isEmpty(profileDetail.website) ? (profileDetail.website != "#lock#" && profileDetail.website != "#credit#") ? webSiteURL(profileDetail.website) : "*******" : "-"}
                        </p>
                      </div>
                    </div>
                  </div>



                </div>
              </div>

              {/* about-company-details */}
              <div className="company-ifno-detial">
                {profileDetail && (!isEmpty(profileDetail.memberdetail) && !isEmpty(profileDetail.memberdetail.about_company)) &&
                  <div className="bg-white section-box">
                    <div className="company-info-lable">
                      <h2 className="head">
                        <span><i className="c-info"></i>
                          Company Information</span>
                      </h2>
                    </div>
                    <div className="company-about ck-edit-cntnt">
                      <div>
                        {/* <h4>About Company</h4> */}
                        {profileDetail && profileDetail.memberdetail && profileDetail.memberdetail.about_company && <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html: companyInfo
                          }}
                        />
                        }
                        {(size(profileDetail.memberdetail.about_company) > 1000) ? (isCompanyInfoExpanded ? <div className="read-more-less-button" onClick={toggleCompanyInfoReadMore} title="Read less">Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div> : <div className="read-more-less-button" onClick={toggleCompanyInfoReadMore} title="Read More">Show More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                      </div>
                    </div>
                  </div>
                }

                <div className="row">
                  <div className="col-xxl-12 col-xl-12">
                    {/* comapny services */}
                    {profileDetail && profileDetail.member_services && !isEmpty(profileDetail.member_services) &&
                      <div className="bg-white section-box">
                        <div className="company-Services-labal d-flex align-items-center">
                          <h2 className="head">
                            <span><i className="services"></i>
                              Services</span>
                          </h2>
                        </div>

                        <div className="searvice-wrape">
                          {profileDetail.member_services.map((val, idx) => {

                            if (idx <= 7) {
                              return <div className="company-Services" key={`mss_${val.id}`}>
                                <i className="sprite tick"></i>
                                <p key={`msp_${val.id}`} className="ps-2">{val.services.service_name}</p>
                              </div>
                            }
                            // else if ((idx > 7) && isExpanded) {
                            //   return <div className="company-Services" key={`mss_${val.id}`}>
                            //     <i className="sprite tick"></i>
                            //     <p key={`msp_${val.id}`} className="ps-2">{val.services.service_name}</p>
                            //   </div>
                            // }

                          })}

                        </div>
                        {/* {(size(profileDetail.member_services) > 7) ? (isExpanded ?
                          <div onClick={toggleReadMore} className="read-more-less-button" title="Read less"> View less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div>
                          : <div onClick={toggleReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>
                        ) : ""} */}
                        {(size(profileDetail.member_services) > 7) ? (isExpanded ?
                          <div></div>
                          : <div onClick={toggleReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>
                        ) : ""}
                      </div>
                    }
                  </div>

                  <div className="col-xxl-6 col-xl-6">
                    {/* Trade Countries*/}
                    {profileDetail && profileDetail.trade_countries && !isEmpty(profileDetail.trade_countries) &&
                      <div className="bg-white section-box">
                        <div className={`company-about border-0`}>
                          <div className="company-info-lable  d-flex align-items-center">
                            <h2 className="head">
                              <span><i className="countries"></i>
                                Trading Countries</span>
                            </h2>
                          </div>
                          <div className="target-country hsn-code">
                            {profileDetail && profileDetail.trade_countries && profileDetail.trade_countries.map((val, idx8) => {
                              // if (idx8 < 8) {
                              //   return <button key={`tc_${val.id}`} className={`${(idx8 < size(profileDetail.trade_countries) - 1) ? 'target_country-right-border' : ''} `}>{val && val.country && val.country.name}</button>
                              // } else if ((idx8 >= 8) && isTradingCountryExpanded) {
                              //   return <button key={`tc_${val.id}`} className={`${(idx8 < size(profileDetail.trade_countries) - 1) ? 'target_country-right-border' : ''} `}>{val && val.country && val.country.name}</button>
                              // }
                              if (idx8 < 8) {
                                return <div key={`tc_${val.id}`} className={`country ${(idx8 < size(profileDetail.trade_countries) - 1) ? '' : ''}`}><span>
                                  <img
                                    src={require(`@/assets/images/svg/flag/${lowerCase(val?.country?.iso3)}.svg`)}
                                    alt={val?.country?.iso3}

                                    className="squre-icon"
                                  />
                                  {val?.country?.name}
                                </span>
                                  {idx8 < profileDetail.trade_countries.slice(0, 8).length - 1 && ' '}</div>
                              }
                            })}
                          </div>
                          {/* {(size(profileDetail.trade_countries) > 8) ? (isTradingCountryExpanded ? <div onClick={toggleTradingCountryReadMore} className="read-more-less-button" title="Read less">View less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div> : <div onClick={toggleTradingCountryReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""} */}
                          {(size(profileDetail.trade_countries) > 8) ? (isTradingCountryExpanded ? <div></div> : <div onClick={toggleTradingCountryReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                        </div>
                      </div>
                    }
                  </div>


                  <div className="col-xxl-6 col-xl-6">
                    {/* HSN code*/}
                    {profileDetail && profileDetail.hs_codes && !isEmpty(profileDetail.hs_codes) &&
                      <div className="company-about">
                        <div className="bg-white section-box">
                          <div className="company-Services-labal d-flex align-items-center">
                            <h2 className="head">
                              <span>
                                <i className="hsn"></i>
                                HSN Code</span>
                            </h2>
                          </div>
                          <div className="hsn-code">
                            {profileDetail && profileDetail.hs_codes && profileDetail.hs_codes.map((val, idx) => {
                              if (idx < 8) {
                                return <button type="button" key={`hs_code_${val.id}`}>{val && val.dictionary_hs_codes && val.dictionary_hs_codes.code}</button>
                              }
                              // else if ((idx >= 8) && isHsnCodeExpanded) {
                              //   return <button type="button" key={`hs_code_${val.id}`}>{val && val.dictionary_hs_codes && val.dictionary_hs_codes.code}</button>
                              // }
                            })}
                          </div>
                          {/* {(size(profileDetail.hs_codes) > 8) ? (isHsnCodeExpanded ? <div onClick={toggleHSNReadMore} className="read-more-less-button" title="Read less"> View less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div> : <div onClick={toggleHSNReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""} */}
                          {(size(profileDetail.hs_codes) > 8) ? (isHsnCodeExpanded ? <div></div> : <div onClick={toggleHSNReadMore} className="read-more-less-button" title="Read More">View More  <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                        </div>
                      </div>
                    }

                    {/* Ports*/}
                    {profileDetail && profileDetail.ports && !isEmpty(profileDetail.ports) &&
                      <div className={`company-about ${isEmpty(profileDetail.ports) ? `border-0` : ``}`}>
                        <div className="bg-white section-box">
                          <div className="company-Services-labal d-flex align-items-center">
                            <h2 className="head">
                              <span><i className="ports"></i>
                                Ports</span>
                            </h2>
                          </div>
                          <div className="hsn-code">
                            {/* <span className="active-country">Canada</span> */}
                            {profileDetail && profileDetail.ports && profileDetail.ports.map((val, idx) => {
                              if (idx < 8) {
                                // return <button type="button" key={`tp_${val.id}`}>{val && val.dictionary_ports && capitalize(val.dictionary_ports.name)}</button>
                                return <div key={`tp_${val.id}`}><span>
                                  {val && val.dictionary_ports && capitalize(val.dictionary_ports.name)}
                                </span>
                                  {idx < profileDetail.ports.slice(0, 8).length - 1 && ' | '}</div>
                              }
                              // else if ((idx >= 8) && isPortExpanded) {
                              //   return <button type="button" key={`tp_${val.id}`}>{val && val.dictionary_ports && capitalize(val.dictionary_ports.name)}</button>
                              // }

                            })}
                          </div>
                          {/* {(size(profileDetail.ports) > 8) ? (isPortExpanded ? <div onClick={togglePortReadMore} className="read-more-less-button" title="Read less"> Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div> : <div onClick={togglePortReadMore} className="read-more-less-button" title="Read More">Show More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                        */}
                          {(size(profileDetail.ports) > 8) ? (isPortExpanded ? <div></div> : <div onClick={togglePortReadMore} className="read-more-less-button" title="Read More">View More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                        </div>
                      </div>
                    }
                  </div>
                </div>

                {size(landing_products) > 0 && <ProductCarousel landing_products={landing_products} handlefavoriteClick={handlefavoriteClick} />}


                <div className="row">
                  <div className="col-xxl-12">
                    {/*company-Images/Video*/}

                    {
                      profileDetail && (!isEmpty(cImages) || !isEmpty(cVideos)) && <ImageVideo profileDetail={profileDetail} cImages={cImages} cVideos={cVideos} />
                    }

                  </div>
                </div>

                <div className="row">
                  <div className="col-xxl-12">
                    {
                      profileDetail && !isEmpty(profileDetail.email) &&
                      <div className="bg-white section-box">
                        <div className="col-xl-12">
                          <div className="company-ifno-detial">
                            <div className="company-info-lable contact">
                              <h2 className="head">
                                <span><i className="c-info-1"></i>
                                  Contact Information</span>
                              </h2>
                            </div>
                          </div>

                          <div className="represetation-wrape">
                            {/* Company-Representative */}
                            {profileDetail &&
                              <div className='company-representative'>
                                <div className=' card-25 view-profile-contact ps-0'>
                                  <div className='view-profile-contact-img'>
                                    <span className="border-wrape">
                                      <img src={profileDetail && !isEmpty(profileDetail.company_representative_image) ? (!maskedData) ? IMAGE_PATH.BASE_URL + profileDetail.company_representative_image : defaultUser : defaultUser} alt=""
                                        className={profileDetail && !isEmpty(profileDetail.company_representative_image) ? (!maskedData) ? "" : "setdefaultImg" : "setdefaultImg"} />
                                    </span>
                                  </div>
                                </div>

                                <div className='card-75'>
                                  <h4 className='contact-title'>Company Representative</h4>

                                  <div className="container">
                                    <div className='row'>
                                      <div className='col-xxl-12 col-xl-12 col-lg-12 col-sm-12 profile-details'>
                                        <p>
                                          <span className='company-Representative-name'>First Name </span>
                                          <span className='company-detials-info'>
                                            {profileDetail && profileDetail.first_name}
                                          </span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name'>Last Name</span>
                                          <span className='company-detials-info'>{profileDetail && (!isEmpty(profileDetail.last_name) ? profileDetail.last_name : "-")}</span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name designation'>Designation</span>
                                          <span className='company-detials-info'>{profileDetail && (!isEmpty(profileDetail.designation) ? profileDetail.designation : "-")}</span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name'>Email</span>
                                          <span className='company-detials-info'> {profileDetail && !isEmpty(profileDetail.email) ? (profileDetail.email != "#lock#" && profileDetail.email != "#credit#") ? profileDetail.email : <button type="button" className="lock-button" onClick={() => profileDetail.email == "#lock#" ? setRegisterModalShow(true) : setCreditModalShow(true) }>View <i className="fa-solid fa-lock"></i></button> : "-"}
                                          </span>
                                        </p>
                                      </div>

                                      <div className='col-xxl-12 col-xl-12 col-lg-12 col-sm-12 profile-details'>
                                        <p>
                                          <span className='company-Representative-name'>Contact</span>
                                          <span className='company-detials-info'>{profileDetail && !isEmpty(profileDetail.phone) ? (profileDetail.phone != "#lock#" && profileDetail.phone != "#credit#") ? profileDetail.phone : <button type="button" className="lock-button" onClick={() => profileDetail.phone == "#lock#" ? setRegisterModalShow(true) : setCreditModalShow(true)}>View <i className="fa-solid fa-lock"></i></button> : "-"}
                                          </span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name'>Mobile</span>
                                          <span className='company-detials-info'>{profileDetail && (!isEmpty(profileDetail.mobile) ? (profileDetail.mobile != "#lock#" && profileDetail.mobile != "#credit#") ? profileDetail.mobile : <button type="button" className="lock-button" onClick={() => profileDetail.mobile == "#lock#" ? setRegisterModalShow(true) : setCreditModalShow(true)}>View <i className="fa-solid fa-lock"></i></button> : "-")}
                                          </span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name'>Country</span>
                                          <span className='company-detials-info'>{profileDetail && (!isEmpty(profileDetail.country) ? profileDetail.country.name : "-")}</span>
                                        </p>

                                        <p>
                                          <span className='company-Representative-name'>City</span>
                                          <span className='company-detials-info'>{profileDetail && (!isEmpty(profileDetail.member_city) ? profileDetail.member_city.name : "-")}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }

                            {/* contact-persont-2 */}
                            {profileDetail && !isEmpty(profileDetail.member_contacts) && (
                              <>
                                {slice(profileDetail.member_contacts, 0, isContactsExpanded ? size(profileDetail.member_contacts) : 1).map((val, idx) => (
                                  <div key={idx} className="company-representative">
                                    <div className="card-25 view-profile-contact ps-0">
                                      <div className="view-profile-contact-img">
                                        <span className="border-wrape">
                                          <img
                                            src={
                                              val && !isEmpty(val.image)
                                                ? !maskedData
                                                  ? IMAGE_PATH.BASE_URL + "/member_contacts/" + val.image
                                                  : defaultUser
                                                : defaultUser
                                            }
                                            alt=""
                                            className={
                                              val && !isEmpty(val.image)
                                                ? !maskedData
                                                  ? ""
                                                  : "setdefaultImg"
                                                : "setdefaultImg"
                                            }
                                          />
                                        </span>
                                      </div>
                                    </div>

                                    <div className="card-75">
                                      <h4 className="contact-title">Staff Person {idx + 1}</h4>
                                      <div className="container">
                                        <div className="row">
                                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12 profile-details">
                                            <p>
                                              <span className="company-Representative-name">
                                                First Name
                                              </span>
                                              <span className="company-detials-info">
                                                {val.first_name}
                                              </span>
                                            </p>

                                            <p>
                                              <span className="company-Representative-name">
                                                Last Name
                                              </span>
                                              <span className="company-detials-info">
                                                {val && !isEmpty(val.last_name) ? val.last_name : "-"}
                                              </span>
                                            </p>

                                            <p>
                                              <span className="company-Representative-name designation">
                                                Designation
                                              </span>
                                              <span className="company-detials-info">
                                                {val && !isEmpty(val.designation) ? val.designation : "-"}
                                              </span>
                                            </p>

                                            <p>
                                              <span className="company-Representative-name">
                                                Email
                                              </span>
                                              <span className="company-detials-info">
                                                {val && !isEmpty(val.email)
                                                  ? (val.email != "#lock#" && val.email != "#credit#")
                                                    ? val.email
                                                    : (
                                                      <button
                                                        type="button"
                                                        className="lock-button"
                                                        onClick={() => val.email == "#lock#" ? setRegisterModalShow(true): setCreditModalShow(true)}
                                                      >
                                                        View <i className="fa-solid fa-lock"></i>
                                                      </button>
                                                    )
                                                  : "-"}
                                              </span>
                                            </p>

                                            <p>
                                              <span className="company-Representative-name">
                                                Mobile
                                              </span>
                                              <span className="company-detials-info">
                                                {val && !isEmpty(val.phone)
                                                  ? (val.phone != "#lock#" && val.phone != "#credit#")
                                                    ? val.phone
                                                    : (
                                                      <button
                                                        type="button"
                                                        className="lock-button"
                                                        onClick={() => val.phone == "#lock#" ? setRegisterModalShow(true) : setCreditModalShow(true)}
                                                      >
                                                        View <i className="fa-solid fa-lock"></i>
                                                      </button>
                                                    )
                                                  : "-"}
                                              </span>
                                            </p>
                                          </div>

                                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                          </div>

                          {size(profileDetail.member_contacts) > 1 && (
                            <div
                              className="read-more-less-button mt-3"
                              onClick={toggleContactsReadMore}
                              title={isContactsExpanded ? "Show less" : "Show more"}
                            >
                              {isContactsExpanded ? (
                                <>Show less <i className="fa fa-angle-double-up" aria-hidden="true"></i></>
                              ) : (
                                <>Show more <i className="fa fa-angle-double-down" aria-hidden="true"></i></>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    }
                  </div>
                  <div className="col-xxl-12">
                    {/* company-location */}
                    {memberHeadAddress && !isEmpty(memberHeadAddress.address1) && (memberHeadAddress.country_id > 0) && (memberHeadAddress.pincode !== null) && (memberHeadAddress.pincode !== "") && <div className="bg-white section-box">
                      <div className="col-xl-12 company-location">
                        <div className="company-ifno-detial">
                          <div className="company-info-lable contact location">
                            <h2 className="head">
                              <span><i className="c-location"></i>
                                Company Location</span>
                            </h2>
                          </div>
                        </div>

                        <div className=' company-representative full-locaiton'>
                          <h4 className="head">Head Office</h4>
                          <div className="container">
                            <div className='row'>
                              <div className='col-xxl-12 col-lg-7 col-md-6 profile-details'>
                                <div className='row'>
                                  <p className='col-lg-5 col-md-5 col-sm-5 col-12 company-Representative-name'>Address Line 1 </p>
                                  <p className='col-lg-7 col-md-7 col-sm-7 col-12 company-detials-info'>
                                    {memberHeadAddress && !isEmpty(memberHeadAddress.address1) ? (memberHeadAddress.address1 != "#lock#" && memberHeadAddress.address1 != "#credit#") ? memberHeadAddress.address1 : <button type="button" className="lock-button" onClick={() => memberHeadAddress.address1 == "#lock#" ? setRegisterModalShow(true): setCreditModalShow(true)}>View <i className="fa-solid fa-lock"></i></button> : "-"}
                                  </p>

                                </div>

                                <div className='row'>
                                  <p className='col-lg-5 col-md-5 col-sm-5 col-12 company-Representative-name'>Address Line 2</p>
                                  <p className='col-lg-7 col-md-7 col-sm-7 col-12 company-detials-info'>{memberHeadAddress && !isEmpty(memberHeadAddress.address2) ? (memberHeadAddress.address2 != "#lock#" && memberHeadAddress.address2 != "#credit#") ? memberHeadAddress.address2 : <button type="button" className="lock-button" onClick={() => memberHeadAddress.address2 == "#lock#" ? setRegisterModalShow(true) : setCreditModalShow(true)}>View <i className="fa-solid fa-lock"></i></button> : "-"}</p>
                                </div>
                              </div>

                              <div className='col-xxl-12 col-lg-5 col-md-6 profile-details'>
                                <div className='row'>
                                  <p className='col-lg-5 col-md-5 col-sm-5 col-12 company-Representative-name'>Country</p>
                                  <p className='col-lg-7 col-md-7 col-sm-7 col-12 company-detials-info'>{memberHeadAddress && !isEmpty(memberHeadAddress.country) ? memberHeadAddress.country.name : "-"}</p>
                                </div>

                                <div className='row'>
                                  <p className='col-lg-5 col-md-5 col-sm-5 col-12 company-Representative-name'>City</p>
                                  <p className='col-lg-7 col-md-7 col-sm-7 col-12 company-detials-info'>{memberHeadAddress && !isEmpty(memberHeadAddress.city) ? memberHeadAddress.city.name : "-"}</p>
                                </div>

                                <div className='row'>
                                  <p className='col-lg-5 col-md-5 col-sm-5 col-12 company-Representative-name'>Postal code</p>
                                  <p className='col-lg-7 col-md-7 col-sm-7 col-12 company-detials-info'>{memberHeadAddress && !isEmpty(memberHeadAddress.pincode) ? memberHeadAddress.pincode : "-"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="container p-0">
                            {/* branch code*/}
                            {profileDetail && profileDetail.branch_office_address && !isEmpty(profileDetail.branch_office_address) && <div className={`company-about ${isEmpty(profileDetail.ports) ? `border-0` : ``}`}>
                              <div className="bg-white section-box p-0 border-0 branch-office">
                                <div className="company-Services-labal d-flex align-items-center">
                                  <h2 className="head">
                                    Branch Offices
                                  </h2>
                                </div>
                                <div className="hsn-code">
                                  {/* <span className="active-country">Canada</span> */}
                                  {profileDetail && profileDetail.branch_office_address && profileDetail.branch_office_address.map((val, idx) => {
                                    return <button type="button" key={`tp_${val.id}`}>{val && capitalize(val.country.name)}</button>
                                  })}
                                </div>
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>

              </div>
            </div>
            {/* left-wrape END */}

            {/* right-wrape START */}
            <div className="right-wrape">
              <div className="company-service-wrap">
                {/* comapny certificate*/}
                {profileDetail && companyStatus == 1 && !isEmpty(profileDetail.orex_certificate) && profileDetail.plan_name !== "Trial" &&
                  < div className="bg-white custom-badge mt-4">
                    <div className="company-Services-labal d-flex align-items-center">
                      <h2 className="head">
                        <span><i className="certificate"></i>
                          Orex Certificate</span>
                      </h2>
                    </div>
                    <div className="mt-3">
                      {profileDetail && !isEmpty(profileDetail.orex_certificate) && (
                        <div onClick={() => setLargeModalShow(true)} style={{ cursor: "pointer" }}>
                          <img src={IMAGE_PATH.BASE_URL + profileDetail.orex_certificate} alt="orex certificate" className="orex-certi" />
                        </div>
                      )}
                    </div>
                  </div>
                }


                {/* comapny certificate*/}
                {profileDetail && companyStatus == 1 && !isEmpty(profileDetail.plan_name) && profileDetail.plan_name !== "Trial" &&
                  <div className="bg-white custom-badge mt-4 membersship-wrape">
                    <div className="company-Services-labal d-flex align-items-center">
                      <h2 className="head">
                        <span>
                          <i className="m-detail"></i>
                          Membership Details
                        </span>
                      </h2>
                    </div>

                    <div className="company-badge">
                      <img
                        src={badgeSrc}
                        alt=""
                      />
                    </div>

                    {profileDetail && profileDetail.plan_name && !isEmpty(profileDetail.orex_certificate) && <div className="text-center blue-bedge"> <b>Plan name </b>{profileDetail && profileDetail.plan_name}</div>}
                    <div className="company-Services bottom-info">
                      <p className="">
                        <span>
                          Valid as of :
                          <b>{!isEmpty(profileDetail.plan_from_date) ? profileDetail.plan_from_date : " - "} </b>
                        </span>
                        <span>
                          Valid Until :
                          <b>{!isEmpty(profileDetail.plan_to_date) ? profileDetail.plan_to_date : " - "}</b>
                        </span>
                      </p>
                    </div>

                  </div>
                }






                {profileDetail && profileDetail.verified_member_certificates && !isEmpty(profileDetail.verified_member_certificates) &&
                  <div className="bg-white  mt-4">
                    <div className="company-Services-labal d-flex align-items-center">
                      <h2 className="head">
                        <span><i className="proof"></i>
                          Business Proof</span>
                      </h2>
                    </div>

                    <div className="mt-2">
                      {profileDetail.verified_member_certificates.map((val, idx2) => {
                        if (idx2 <= 7) {
                          return <div className="company-Services" key={`mc_${val.id}`}>
                            <i className="sprite tick"></i>
                            <p key={`mcp_${val.id}`} className="ps-2">{val && val.certificates && val.certificates.name}</p>
                          </div>
                        } else if ((idx2 > 7) && isCertiExpanded) {
                          return <div className="company-Services" key={`mc_${val.id}`}>
                            <i className="sprite tick"></i>
                            <p key={`mcp_${val.id}`} className="ps-2">{val && val.certificates && val.certificates.name}</p>
                          </div>
                        }
                      })}

                    </div>
                    {(size(profileDetail.verified_member_certificates) > 7) ? (isCertiExpanded ? <div className="read-more-less-button" onClick={toggleCertiReadMore} title="Read less">Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i></div> : <div className="read-more-less-button" onClick={toggleCertiReadMore} title="Read More">Show More <i class="fa fa-angle-double-down" aria-hidden="true"></i></div>) : ""}
                  </div>
                }
              </div>
            </div>
            {/* right-wrape END */}
          </div>
        </div>
      </div >

      {/* section---2 */}

      {/* <Register /> */}

    </section >

    <PopUp
      title={popupTitle}
      smallmodalShow={mediumModalShow}
      setSmallModalShow={setMediumModalShow}
      className="landing-modal"
    // onSubmit={handleRegistrationPopup}
    // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
    // }
    >



      <div className="row">

        {popupTitle === 'Services' && profileDetail && profileDetail?.member_services.map((val, idx) => (
          <div className="col-sm-6" key={`msp_${val.id}`}>
            <ul>
              <li>
                <span><i class="sprite tick"></i> {val.services.service_name}</span></li>
            </ul>

          </div>
        ))}

        <div className="hsn-code">
          {popupTitle === 'HSN Code' && profileDetail && profileDetail.hs_codes && profileDetail.hs_codes.map((val, idx) => (
            <button type="button" key={`msp_${val.id}`}>{val && val.dictionary_hs_codes && val.dictionary_hs_codes.code}</button>
          ))}
        </div>


        {popupTitle === 'Trading Countries' && profileDetail && profileDetail.trade_countries && profileDetail.trade_countries.map((val, idx8) => (
          <div className="col-md-4 col-sm-6" key={`msp_${val.id}`}>
            <ul>
              <li>
                <img
                  src={require(`@/assets/images/svg/flag/${lowerCase(val?.country?.iso3)}.svg`)}
                  alt={val?.country?.iso3}
                  height="15"
                  className="squre-icon"
                />{" "}
                <span>{val?.country?.name}</span></li>
            </ul>
          </div>
        ))}


        {popupTitle === 'Ports' && profileDetail && profileDetail.ports && profileDetail.ports.map((val, idx) => (
          <div className="col-sm-6" key={`msp_${val.id}`}>
            <ul>
              <li>
                <span>
                  <i class="sprite tick"></i>
                  {val && val.dictionary_ports && capitalize(val.dictionary_ports.name)}
                </span>
              </li>
            </ul>
          </div>
        ))}

      </div>
    </PopUp>

    {
      registermodalShow && <RegistrationPopup
        title=""
        smallmodalShow={registermodalShow}
        setSmallModalShow={setRegisterModalShow}
        onSubmit={handleRegistrationPopup}
        okButtonLabel={'REGISTER NOW'
        }
      >
        {(() => {
          if (user && isPreKYCUser) {
            return (
              <div className="new-pop">
                <div className="img-wrape"></div>
                <div className="detail-wrape">
                  <div className="inner">
                    <h5 className="registor-now">Grow With Us!</h5>
                    <h6>Welcome! Let’s Get You Started</h6>
                    <p className="registor-now-text">
                      Access special features, get personalized recommendations and connect with a growing community.
                    </p>
                    {/* <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                            redirectFun(e, user.member_id)
                          }}>
                            Go to Profile
                          </Link> */}
                    <button type="button" className="btn secondry-btn" onClick={handleUpgradePlanClick}>
                      Upgrade Plan
                    </button>
                  </div>
                </div>
              </div>
            );
          } else {
            return (<div className="new-pop">
              <div className="img-wrape"></div>
              <div className="detail-wrape">
                <div className="inner">
                  <h5 className="registor-now">Grow With Us!</h5>
                  <p>
                    Select your role to get started:
                  </p>
                  <Link
                    to={publicRoutePaths.REGISTRATION.path}
                    className="popup-category-btn"
                    onClick={(e) => {
                      redirectFun(e, null)
                    }}
                  >
                    <span className="icon supplier"></span>
                    <span className="detail">
                      <h3>Supplier</h3>
                      <p>Sell and showcase your products</p>
                    </span>
                    {/* <p>
                      <span>Sell and showcase your products</span>
                    </p>Supplier */}

                  </Link>
                  <Link
                    to={publicRoutePaths.REGISTRATION.path}
                    className="popup-category-btn"
                    onClick={(e) => {
                      redirectFun(e, null)
                    }}
                  >
                    <span className="icon logistics"></span>
                    <span className="detail">
                      <h3>Logistic Partner</h3>
                      <p>Scaling Your Growth Through Reliable Logistics</p>
                    </span>


                  </Link>
                  <button type="button" className="popup-category-btn" onClick={handleInqModal}>
                    <span className="icon buyer"></span>
                    <span className="detail">
                      <h3>Buyer</h3>
                      <p>Discover and connect with suppliers</p>
                    </span>
                    {/* Buyer
                    <p>
                      <span>Discover and connect with suppliers</span>
                    </p> */}
                  </button>

                </div>
              </div>
            </div>
            );
          }
        })()}

      </RegistrationPopup>
    }

    {
      inqmodalshow && <PopUp
        title="Business Inquiry"
        smallmodalShow={inqmodalshow}
        setSmallModalShow={setInqModalShow}
        className="book-demo"
        size="lg"
      >
        <SupplierInqPopup data={selectedSupplier} setInqModalShow={setInqModalShow} from={!user ? "continue_buyer" : ""} />
      </PopUp>
    }

    {
      regModal && <RegistrationPopup
      title=""
      smallmodalShow={regModal}
      setSmallModalShow={setRegModalShow}
      onSubmit={handleRegisterBtnClick}
      okButtonLabel="REGISTER NOW"
    >
      <div className="new-pop">
        <div className="img-wrape"></div>
        <div className="detail-wrape">
          <div className="inner">
            <h5 className="registor-now">Grow With Us!</h5>
            <h6>Register now to get more benefits!</h6>
            <p className="registor-now-text">
              Access special features, get personalized recommendations and connect with a growing community.
            </p>
            <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank" href={publicRoutePaths.REGISTRATION.path} >Register Now</Link>
          </div>
        </div>
      </div>
    </RegistrationPopup>
    }

    {
      creditModal && <RegistrationPopup
      title=""
      smallmodalShow={creditModal}
      setSmallModalShow={setCreditModalShow}
      // onSubmit={handleRegisterBtnClick}
      // okButtonLabel="REGISTER NOW"
    >
      <div className="new-pop credit-limit-popup">
        <div className="img-wrape"></div>
        <div className="detail-wrape">
          <div className="inner">
            <h5 className="registor-now">You’re All Caught Up for Today!</h5>
            <p className="registor-now-text">
              You’ve reached today’s profile view limit. You can continue exploring profiles tomorrow or contact our support team for assistance on <a href={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`}> {process.env.REACT_APP_SUPPORT_MAIL} </a>
            </p>
          </div>
        </div>
      </div>
    </RegistrationPopup>
    }


    <ConsentManager data={""} />
    <ToastContainer />
  </>
  );
}


const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLandingProfileData: (api_name, id) => dispatch(getLandingProfile(api_name, id)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    updateMemberCredit: (viewer_id, viewed_id) => dispatch(updateMemberCredit(viewer_id, viewed_id))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Index));
